import { render } from "./MySubordinates.vue?vue&type=template&id=5a7888e2"
import script from "./MySubordinates.vue?vue&type=script&lang=js"
export * from "./MySubordinates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__